export default "__VITE_ASSET__Cuz$9UeG__"